var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-search-form',{on:{"getChannelData":_vm.getChannelData}}),_c('report-grid-form',{attrs:{"currentGridType":_vm.currentGridType,"totalReportData":_vm.totalReportData,"reportSegment":_vm.reportSegment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }